module.exports = __webpack_public_path__ + "media/tea in the evening.14be0fcf.mp3";